export default {
  path: '/site',
  name: 'site',
  redirect: { name: 'job.feed-page' },
  component: () => import(/* webpackChunkName: "site" */ '@/views/site'),
  children: [
    {
      path: '/sites/:name/:id',
      name: 'site.view-site-page',
      component: () =>
        import(/* webpackChunkName: "view-site-page" */ '@/views/site/ViewSitePage.vue')
    }
  ]
}
